var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');
require('../user');
require('../fullscreen-loading');
require('../thankyou-modal');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$verifyModal', [
    '$log',
    '$location',
    '$uibModal',
    '$user',
    '$fsloading',
    '$thankyouModal',

    function $verifyModalService($log, $location, $uibModal, $user, $fsloading, $thankyouModal) {
        return function openVerifyModal() {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: [
                    '$scope',

                    function verifyModalCtrl($scope) {
                        $scope.user = $user;

                        // Functions
                        $scope.resendTextVerification = function resendTextVerification() {
                            $fsloading.show();

                            $user.sendPhoneVerification($location.absUrl())
                                .catch(function onPhoneVerificationError(err) {
                                    $log.error(err);
                                })
                                .finally(function () {
                                    $fsloading.hide();
                                    $scope.$close();
                                    $thankyouModal('You will now receive a notification with a confirmation link. Once received through text or email, just click the link to verify your account. Please note: This link will expire in 24hrs.');
                                });
                        };

                        $scope.resendEmailVerification = function resendTextVerification() {
                            $fsloading.show();

                            $user.sendEmailVerification($location.absUrl())
                                .catch(function onEmailVerificationError(err) {
                                    $log.error(err);
                                })
                                .finally(function () {
                                    $fsloading.hide();
                                    $scope.$close();
                                    $thankyouModal('You will now receive a notification with a confirmation link. Once received through text or email, just click the link to verify your account. Please note: This link will expire in 24hrs.');
                                });
                        };
                    }
                ],
                backdrop: 'static',
                windowClass: 'verify-modal'
            });

            return modal;
        };
    }
]);
